import { createHashHistory } from 'history';
import { getAuthCode, logout } from './AuthUtils';
const options = (method, body, headers) => {
  const opt = {
    mode: 'cors',
    method,
    headers: {},
    cache: 'no-cache'
  };
  const headersTobeEdited = opt.headers;
  const accessToken = getAuthCode();
  if (accessToken) {
    headersTobeEdited.Authorization = `Bearer ${accessToken}`;
  }
  if (body) {
    opt.body = body;
  }

  // Add extra headers to request if they exist
  if (headers !== null && headers !== undefined) {
    Object.keys(headers).forEach(key => {
      headersTobeEdited[key] = headers[key];
    });
  }
  return opt;
};
const requestWithHeaders = async (url, method, body, headers) => {
  const response = await fetch(url, options(method, body, headers));
  if (response.status === 401) {
    logout();
  }
  if (response.status === 403) {
    createHashHistory().push('/forbidden');
  }
  return response;
};
const requestJson = async (url, method, body) => {
  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  };
  const response = await requestWithHeaders(url, method, body, headers);
  if (response) {
    return response.json();
  }
  return null;
};
const tradeAuthCode = async (url, authCode, redirectUri, codeVerifier, clientId) => {
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    Accept: 'application/json'
  };
  const body = `code=${authCode}&grant_type=authorization_code&redirect_uri=${redirectUri}&code_verifier=${codeVerifier}&client_id=${clientId}`;
  return requestWithHeaders(url, 'POST', body, headers);
};

// Assumes hostname in following formats:
//  localhost (localhost)
//  hyrule-dev.noa.nintendo.com (dev)
//  hyrule-test.noa.nintendo.com (test)
//  hyrule.noa.nintendo.com (prod)
const getEnvironmentName = () => {
  const {
    hostname
  } = window.location;
  let environment = 'UNKNOWN';
  if (hostname) {
    const splitHostname = hostname.split('.');

    // check for localhost
    if (splitHostname.length === 1) {
      environment = splitHostname[0];
    } else {
      const topLevelName = splitHostname[0].split('-');

      // check for prod
      if (topLevelName.length === 1) {
        environment = null;
      } else if (topLevelName.length > 1) {
        environment = topLevelName[1];
      }
    }
  }
  return environment;
};
export default {
  requestJson,
  requestWithHeaders,
  getEnvironmentName,
  tradeAuthCode
};